"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketClientConnection = void 0;
const utils_1 = require("@streamr/utils");
const websocket_1 = require("websocket");
const AbstractWebsocketClientConnection_1 = require("./AbstractWebsocketClientConnection");
const logger = new utils_1.Logger(module);
const BINARY_TYPE = 'arraybuffer';
class WebsocketClientConnection extends AbstractWebsocketClientConnection_1.AbstractWebsocketClientConnection {
    socket;
    // TODO explicit default value for "selfSigned" or make it required
    connect(address, selfSigned) {
        if (!this.destroyed) {
            this.socket = new websocket_1.w3cwebsocket(address, undefined, undefined, undefined, { rejectUnauthorized: !selfSigned });
            this.socket.binaryType = BINARY_TYPE;
            this.socket.onerror = (error) => this.onError(error);
            this.socket.onopen = () => this.onOpen();
            this.socket.onclose = (event) => this.onClose(event.code, event.reason);
            this.socket.onmessage = (message) => {
                if (!this.destroyed) {
                    if (typeof message.data === 'string') {
                        logger.debug('Received string data, only binary data is supported');
                    }
                    else {
                        this.onMessage(new Uint8Array(message.data));
                    }
                }
            };
        }
        else {
            logger.debug('Tried to connect() a stopped connection');
        }
    }
    stopListening() {
        if (this.socket) {
            this.socket.onopen = undefined;
            this.socket.onclose = undefined;
            this.socket.onerror = undefined;
            this.socket.onmessage = undefined;
        }
    }
}
exports.WebsocketClientConnection = WebsocketClientConnection;
//# sourceMappingURL=BrowserWebsocketClientConnection.js.map